module.exports = __webpack_public_path__ + "img/nodejs-banner.a35fa4f1.webp";